"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_truncate_markup_1 = __importDefault(require("react-truncate-markup"));
exports.AcTextTruncate = function (props) {
    var text = props.text, maxLines = props.maxLines, maxWidth = props.maxWidth, onEdit = props.onEdit;
    var defaultMaxWidth = '200px';
    var ellipsis = react_1.default.createElement("i", { className: "fal fa-ellipsis-h fa-fw" });
    var edit = (react_1.default.createElement("i", { className: "far fa-pencil ac-table--no-row-click text-secondary fa-fw", onClick: onEdit }));
    var _a = react_1.useState(), isTruncate = _a[0], setIsTruncate = _a[1];
    return (react_1.default.createElement("div", { className: "d-flex", style: {
            width: maxWidth ? maxWidth + "px" : defaultMaxWidth,
        } },
        react_1.default.createElement(react_truncate_markup_1.default, { lines: maxLines, onTruncate: function (wasTruncated) { return setIsTruncate(wasTruncated); }, ellipsis: react_1.default.createElement("span", { className: "position-relative", style: { zIndex: 1 } },
                ellipsis,
                edit) },
            react_1.default.createElement("div", null, text)),
        !isTruncate && react_1.default.createElement("span", { className: "ml-auto mt-auto" }, edit)));
};
exports.AcTextTruncate.displayName = 'AcTextTruncate';
//# sourceMappingURL=AcTextTruncate.js.map